import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
  super.connectedCallback();

  mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
  this.setAttribute('initialized', '');

  // 👇 CODE DU BOUTON "CHARGER PLUS"
  const loadMoreBtn = this.querySelector('[data-load-more]');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const currentPageURL = loadMoreBtn.dataset.url;
      if (!currentPageURL) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Chargement...';

      try {
        const response = await fetch(currentPageURL);
        const html = await response.text();
        const dom = new DOMParser().parseFromString(html, 'text/html');

        const newItems = dom.querySelectorAll('[ref="grid"] .product-grid__item');
        const grid = this.querySelector('[ref="grid"]');

        newItems.forEach(item => grid.appendChild(item));
        // Met à jour la pagination (numéro actif)
const newPagination = dom.querySelector('.collection-pagination');
const currentPagination = this.querySelector('.collection-pagination');
if (newPagination && currentPagination) {
  currentPagination.innerHTML = newPagination.innerHTML;
}


        // Met à jour l’URL dans la barre d’adresse
        const loadedPageParam = new URL(currentPageURL, window.location.origin).searchParams.get('page');
        if (loadedPageParam) {
          const newURL = new URL(window.location.href);
          newURL.searchParams.set('page', loadedPageParam);
          history.pushState(null, '', newURL.toString());
        }

        // Prépare le bouton pour la page suivante (ou supprime-le)
        const nextBtn = dom.querySelector('[data-load-more]');
        if (nextBtn) {
          loadMoreBtn.dataset.url = nextBtn.dataset.url;
          loadMoreBtn.textContent = 'Charger plus';
          loadMoreBtn.disabled = false;
        } else {
          loadMoreBtn.remove();
        }

      } catch (err) {
        console.error('Erreur lors du chargement des produits :', err);
        loadMoreBtn.textContent = 'Erreur, réessayer';
        loadMoreBtn.disabled = false;
      }
    });
  }
}


  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
